import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../../config/api";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";
import Cookies from "js-cookie";

export const AddGroupType = () => {
    const navigate = useNavigate();
    const token = Cookies.get("token-velox-charter");
    const [name, setName] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [enabled, setEnabled] = useState<string>("No");

    const [pleaseWaitPopup, setPleaseWaitPopup] =
        useState<boolean>(false);

    const handleSubmit = async (
        e: React.FormEvent<HTMLFormElement>
    ) => {
        e.preventDefault();

        setPleaseWaitPopup(true);

        const payload = {
            name: name.trim(),
            description: description.trim(),
            isActive: enabled === "Yes"
        };

        await axios
            .post(
                `${baseURL}group-types/`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    withCredentials: false
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);

                console.error(
                    "Error creating group type:",
                    error
                );
            });
    };

    return (
        <>
            <div className="px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto">

                <div className="w-full bg-white p-4 rounded-md">

                    <h2 className="text-lg font-semibold">
                        Add Group Type
                    </h2>

                    <div className="mt-2 p-2">

                        <form onSubmit={handleSubmit}>

                            <div className="w-full">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-2.5">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Name{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={name}
                                            placeholder="e.g. Corporate Group"
                                            onChange={(e) =>
                                                setName(e.target.value)
                                            }
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Active
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={enabled}
                                            onChange={(e) =>
                                                setEnabled(e.target.value)
                                            }
                                        >
                                            <option value="Yes">
                                                Yes
                                            </option>

                                            <option value="No">
                                                No
                                            </option>
                                        </select>
                                    </div>

                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-2.5">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Description
                                        </label>

                                        <textarea
                                            rows={4}
                                            value={description}
                                            onChange={(e) =>
                                                setDescription(
                                                    e.target.value
                                                )
                                            }
                                            placeholder="Enter group type description"
                                            className="w-full p-4 border border-gray-300 rounded-md bg-white resize-none outline-none focus:border-primary"
                                        />
                                    </div>

                                </div>

                                <div className="flex flex-col sm:flex-row gap-4 mt-6">

                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-white text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>

                                </div>

                            </div>

                        </form>

                    </div>
                </div>
            </div>

            <PleasewaitPopup
                showPopup={pleaseWaitPopup}
            />
        </>
    );
};